import { render, staticRenderFns } from "./SplitShipmentAddressManager.vue?vue&type=template&id=18940a73&scoped=true"
import script from "./SplitShipmentAddressManager.vue?vue&type=script&lang=js"
export * from "./SplitShipmentAddressManager.vue?vue&type=script&lang=js"
import style0 from "./SplitShipmentAddressManager.vue?vue&type=style&index=0&id=18940a73&prod&scoped=true&lang=css"
import style1 from "./SplitShipmentAddressManager.vue?vue&type=style&index=1&id=18940a73&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18940a73",
  null
  
)

export default component.exports